<template>
  <div v-if="getPublishedSpeakers && isLoaded">
    <v-dialog persistent v-model="speakersModalWindow" max-width="800px">
      <v-btn color="primary" dark slot="activator" v-if="isWriteAvailable">Add speakers</v-btn>
      <v-list
        @mousemove.native="moveList"
        @mouseover.native="overList"
        @mouseleave.native="leaveList"
        class="speakers-list">
        <div
          class="warning-modal"
          :style="modalPosition"
          @mouseover="overModal"
        >
          You can add only 10 speakers
        </div>
        <v-list-tile
          avatar
          v-for="item in publishedSpeakers"
          :key="item.id"
          @click="addSpeaker(item)"
        >
          <v-list-tile-action>
            <v-icon
              color="success"
              v-if="speakersIds.indexOf(item.id) < 0"
            >
              check_box_outline_blank
            </v-icon>
            <v-icon
              color="success"
              v-else
            >
              check_box
            </v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title v-text="item.name"/>
          </v-list-tile-content>
          <v-list-tile-avatar>
            <img :src="item.image">
          </v-list-tile-avatar>
        </v-list-tile>
        <v-btn
          color="grey lighten-1"
          @click="toggleModal('speakersModalWindow')"
        >
          Close
        </v-btn>
        <v-btn
          color="info"
          @click="submitSpeakers"
        >
          Save
        </v-btn>
      </v-list>
    </v-dialog>
    <v-btn
      color="success"
      dark
      @click="saveOrder"
    >
      Save speakers order
    </v-btn>
    <v-layout row wrap justify-start>
      <drag
        v-model="speakersIds"
        :options="dragOptions"
        class="drag-container"
      >
        <v-card
          v-for="(id, index) in speakersIds"
          class="mx-2 mb-2"
          :key="`id-${index}`"
          width="100"
        >
          <v-flex
            align-center
            justify-center
            v-if="speakerObj(id)"
          >
            <v-card-media
              height="60px"
              :src="speakerObj(id).image"
            />
            <h3 class="pa-2">{{speakerObj(id).name}}</h3>
          </v-flex>
        </v-card>
      </drag>
    </v-layout>
  </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { equals, clone, contains, pathOr, remove, map, prop } from 'ramda'
  import mixins from '@/utils/mixins'

  export default {
    name: 'speakers-home-page',
    mixins: [mixins.isWriteAvailable],
    data () {
      return {
        speakersModalWindow: false,
        publishedSpeakers: null,
        speakersIds: null,
        dragOptions: {
          ghostClass: 'before-drag-drop'
        },
        // DON'T DELETE! need for isWriteAvailable mixin
        scopeForWrite: 'speakers:write',
        modalStyles: {
          display: 'none',
          offsetX: '',
          offsetY: ''
        },
        overSelectedSpeakers: false,
        isOver: false,
        isLoaded: false
      }
    },
    computed: {
      ...mapGetters([
        'getPublishedSpeakers',
        'getHomepageSpeakers'
      ]),
      modalPosition () {
        return {
          display: this.modalStyles.display = this.isModal ? 'flex' : 'none',
          left: `${this.modalStyles.offsetX}px`,
          top: `${this.modalStyles.offsetY}px`
        }
      },
      isModal () {
        return this.overSelectedSpeakers && this.isOver
      }
    },
    watch: {
      getPublishedSpeakers: {
        immediate: true,
        handler () {
          if (this.getPublishedSpeakers) {
            this.publishedSpeakers = [...this.getPublishedSpeakers]
          }
        }
      },
      getHomepageSpeakers: {
        immediate: true,
        handler () {
          if (this.getHomepageSpeakers) {
            this.speakersIds = this.getHomepageSpeakers.map(speaker => speaker.id)
            this.speakersIds = this.speakersIds.map((speaker, index) => (
              this.getHomepageSpeakers.find(item => item.order === index).id)
            )
          }
        }
      }
    },
    async created () {
      await this.fetchSpeakersList()
      await this.fetchSpeakersVisibleHomepage()
      this.isLoaded = true
    },
    methods: {
      ...mapActions([
        'fetchSpeakersList',
        'fetchSpeakersVisibleHomepage',
        'setSpeakersVisibleHomepage',
        'patchOrdersSpeaker'
      ]),
      hideModal () {
        this.isOver = false
      },
      position (e) {
        if (this.isModal) {
          this.modalStyles.offsetX = e.offsetX
          this.modalStyles.offsetY = e.pageY
        }
      },
      overModal () {
        this.hideModal()
      },
      overList (e) {
        this.isOver = true
        this.position(e)
      },
      moveList (e) {
        this.position(e)
      },
      leaveList () {
        this.hideModal()
      },
      addSpeaker (item) {
        let index = this.speakersIds.indexOf(item.id)
        if (index >= 0) {
          this.speakersIds = remove(index, 1, this.speakersIds)
        }
        if (this.speakersIds.length === 10) {
          this.overSelectedSpeakers = true
          setTimeout(()=> {this.overSelectedSpeakers = false}, 2500)
          return
        }
        if (index < 0) {
          this.speakersIds = [...this.speakersIds, item.id]
        }
      },
      speakerObj (id) {
        return this.publishedSpeakers.find((item) => item.id === id)
      },
      toggleModal (varModal) {
        this[varModal] = !this[varModal]
      },
      async submitSpeakers () {
        this.saveOrder()
        await this.setSpeakersVisibleHomepage(this.speakersIds)
        this.toggleModal('speakersModalWindow')
        this.fetchSpeakersVisibleHomepage()
      },
      async saveOrder () {
        const speakersList = this.speakersIds.map((speaker) => this.publishedSpeakers.find(item => item.id === speaker))
        const sortedSpeakersList = speakersList.map((speaker, index) => {return {...speaker, order: index}})
        await this.patchOrdersSpeaker(sortedSpeakersList)
        this.fetchSpeakersVisibleHomepage()
      }
    }
  }
</script>

<style lang="scss" scoped>
  .drag-container {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
  }

  .before-drag-drop {
    opacity: 0.35;
    background: lightgray;
  }

  .speakers-list {
    position: relative;
  }

  .warning-modal {
    width: 270px;
    min-height: 100px;
    background-color: #fff;
    border: 2px solid #ff4f65;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem;
    font-weight: 500;
    box-shadow: -1px -4px 85px -8px rgba(0, 0, 0, 0.75);
    transform: translate(35%, -170%);
    position: absolute;
    z-index: 9;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/Speakers/SpeakersForHomePage/index.vue